import { CircularProgress, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useData, useStatePtr } from "@pure-ptr/react";
import React, { useContext,useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { getUnderpaymentsSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';
import { DashboardFiltersContext, useClaimAnalysisPage, useStyles } from './Dashboard';
import { nonPaginatedSorting } from '../../util';
import WidgetsSortingComponent from './WidgetsSortingComponent';

export const UnderpaymentsWidget = () => {
    const classes = useStyles();
    const { dateRange } = useContext(DashboardFiltersContext);

    const { data, isPending } = useData( async () => {
        const result = await getUnderpaymentsSummary(dateRange.startdate, dateRange.enddate); 
        return result;
    }, [ dateRange ]);

    const [sortConfig, setSortConfig] = useState({ key: 'contractName', direction: 'asc' }); 

       const sortableColumns = [
        { key: 'contractName', label: 'Contract' },
        { key: 'totalUnderPayments', label: 'Underpayments' },
        { key: 'totalDenials', label: 'Denials' },
    ];

    const openPtr = useStatePtr( {} );

    const handleUnderpaymentsRowClick = (contractName) => {
        openPtr.set((prevState) => ({
            ...prevState, 
            [contractName]: !prevState[contractName],
        }));
    }

    const openClaimAnalysis = useClaimAnalysisPage();

    const handleUnderpaymentsAmountClick = (contractName, isDenial, facilityId = null) => {
        let filters = [
            {
                actualFilter: true, 
                equator: "greater_than", 
                field: "variance", 
                value: 0
            },
            {
                actualFilter: true, 
                equator: "equals", 
                field: "contract.name", 
                value: contractName
            }
        ];

        if(facilityId != null) {
            filters.push({
                actualFilter: true, 
                equator: "equals", 
                field: "facilityId", 
                value: facilityId
            });
        }

        openClaimAnalysis({
            filter: filters,
            customFilter: [
                {
                    customFilter: true, 
                    equator: "greater_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.startdate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "less_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.enddate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "isDenial", 
                    value: isDenial
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "acknowledged", 
                    value: false
                }
            ],
            significance: false,
        });
    }

    const sortedData = React.useMemo(
        () =>
            nonPaginatedSorting([sortConfig], [...(data?.slice(0, 10) || [])])
                ?.tableData,
        [data, sortConfig]
    );

    return isPending ? (
        <CircularProgress />
        ) : (
        <Table stickyHeader>
            <TableHead>
            <TableRow key='underpaymentsHeader'>
                <WidgetsSortingComponent sortableColumns={sortableColumns} sortConfig={sortConfig} setSortConfig={setSortConfig}/>
            </TableRow>
            </TableHead>
            <TableBody>
            {sortedData?.map((entry) => (
                <>
                <TableRow key={entry.contractName} className={entry.underpaymentsByFacilities?.length > 0 ? classes.greenHeaderRow : ''}>
                    <TableCell sx={{width: "60%"}}>
                        {entry.underpaymentsByFacilities?.length > 0 && (
                            <IconButton sx={{padding: "0 10px 0 0"}} onClick={() => handleUnderpaymentsRowClick(entry.contractName)}>
                                {openPtr.value[entry.contractName] ? <ArrowDropDownIcon /> : <ArrowRightIcon />  }
                            </IconButton>
                        )}
                        {entry.contractName}
                    </TableCell>
                    <TableCell sx={{width: "20%"}}><Typography onClick={()=> handleUnderpaymentsAmountClick(entry.contractName,false)} variant="body2" className={entry.totalUnderPayments ? classes.link : ''}>{entry.totalUnderPayments ? asDollarsWithZero(entry.totalUnderPayments) : 'N/A'}</Typography></TableCell>
                    <TableCell sx={{width: "20%"}}><Typography onClick={()=> handleUnderpaymentsAmountClick(entry.contractName,true)} variant="body2" className={entry.totalDenials ? classes.link : ''}>{entry.totalDenials ? asDollarsWithZero(entry.totalDenials) : 'N/A'}</Typography></TableCell>
                </TableRow>

                {entry.underpaymentsByFacilities?.length > 0 && (
                    <TableRow key={`${entry.contractName}-childRow`}>
                        <TableCell colSpan={3} sx={{padding: "0px", border: 0 }}>
                            <Collapse in={openPtr.value[entry.contractName]} timeout="auto" unmountOnExit>
                            <Table sx={{width: "100%", margin: "0px 0px"}}>
                                <TableBody>
                                {entry.underpaymentsByFacilities?.map((facility, index) => (
                                    <TableRow key={`${entry.contractName}-${index}`}>
                                        <TableCell sx={{width: "10%"}}></TableCell>
                                        <TableCell sx={{width: "50%"}}>{facility.facilityName ?? "N/A"}</TableCell>
                                        <TableCell sx={{width: "20%"}}><Typography onClick={()=> handleUnderpaymentsAmountClick(entry.contractName,false, facility.facilityId ?? "none")} variant="body2" className={facility.totalUnderPayments ? classes.link : ''}>{facility.totalUnderPayments ? asDollarsWithZero(facility.totalUnderPayments) : 'N/A'}</Typography></TableCell>
                                        <TableCell sx={{width: "20%"}}><Typography onClick={()=> handleUnderpaymentsAmountClick(entry.contractName,true, facility.facilityId ?? "none")} variant="body2" className={facility.totalDenials ? classes.link : ''}>{facility.totalDenials ? asDollarsWithZero(facility.totalDenials) : 'N/A'}</Typography></TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                )}
                
                </>
            ))}
            </TableBody>
        </Table>
    )
}